import React, { useEffect, useState } from 'react'
import { ITripGroupRides } from 'src/types/trip-group-rides'
import Edit from 'src/components/icons/ui/Pencil'
import UpdatePassengerDetailsModal from './update-passenger-details-modal/UpdatePassengerDetailsModal'
import ConfimationDialogModal from './confirmation-dialog-modal/ConfirmationDialogModal'

interface TripPaymentDisplayProps {
  tripsGroupRides: ITripGroupRides[]
  paymentMode: string
  riderCount?: number
  serviceId: string
  tripId: string
  operatorId?: string
}

const TripPaymentDisplay: React.FC<TripPaymentDisplayProps> = ({
  paymentMode,
  riderCount,
  tripsGroupRides,
  serviceId,
  tripId,
  operatorId = ''
}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [isConfirmOpen, setIsConfirmOpen] = useState<boolean>(false)
  const [data, setData] = useState<ITripGroupRides[]>([])

  useEffect(() => {
    const data =
      tripsGroupRides.length > 0
        ? tripsGroupRides
        : [
            {
              id: '',
              tripId: '',
              riderType: '',
              fareType: paymentMode,
              amount: 0,
              orcaNumber: 0,
              totalRider: riderCount || 0,
              totalAmount: 0
            }
          ]

    setData(data)
  }, [])

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',

    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })

  const renderTable = (tripGroupRides: ITripGroupRides[]) => (
    <div className='flex flex-column w-100'>
      <div className='flex'>
        <div className='col-4 center'>
          {tripGroupRides.length > 0 && tripGroupRides[0].id ? 'Rider Type' : 'Rider Count'}
        </div>
        <div className='col-4 center'>
          {tripGroupRides.length > 0 && tripGroupRides[0].id ? 'Fare Type' : 'Payment Mode'}
        </div>
        <div className='col-4 center'>{'Total'}</div>
      </div>
      {tripGroupRides.map((item, index) => (
        <div className='flex mt1' key={index}>
          <div className='col-4 center'>{item.totalRider > 0 && `${item.totalRider} ${item.riderType}`}</div>
          <div className='col-4 center'>{item.fareType}</div>
          <div className='col-4 center'>{formatter.format(item.amount * item.totalRider)}</div>
        </div>
      ))}
    </div>
  )

  return (
    <div>
      <div className='mt1 mb1' style={{ width: '100%' }}>
        <div className='flex items-center justify-center mt1 h5'>
          <div className='m0 h5 font-black' style={{ width: '100%' }}>
            {renderTable(data)}
          </div>
          <span onClick={() => setIsModalOpen(true)}>
            <Edit className='icon--16x16 cursor--pointer' />
          </span>
          {isModalOpen === true && (
            <UpdatePassengerDetailsModal
              setIsModalOpen={setIsModalOpen}
              setIsConfirmOpen={setIsConfirmOpen}
              tripsGroupRides={data}
              setTripGroupRides={setData}
              serviceId={serviceId}
              tripId={tripId}
              operatorId={operatorId}
            />
          )}
          {isConfirmOpen === true && (
            <ConfimationDialogModal setIsModalOpen={setIsConfirmOpen} tripsGroupRides={data} />
          )}
        </div>
      </div>
    </div>
  )
}

export default TripPaymentDisplay



// WEBPACK FOOTER //
// ./src/components/trips/trip-detail/TripRiderDetails.tsx